import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Alan, Buton } from "@kantin/ui";
import { apiYaz } from "./api.js";
import { IslemDurumu, SirKopyala } from "./ortak.js";
import { veliParolasiUret } from "./veliParolasiUret.js";

export function ParolaAlani({
  deger,
  degistir,
  kilitli = false,
}: {
  deger: string;
  degistir: (parola: string) => void;
  kilitli?: boolean;
}) {
  const [hata, setHata] = useState<string | null>(null);
  return (
    <div className="flex min-w-0 flex-col gap-2">
      <Alan
        etiket="Parola"
        value={deger}
        maxLength={64}
        autoComplete="new-password"
        autoCapitalize="none"
        spellCheck={false}
        disabled={kilitli}
        onChange={(e) => degistir(e.target.value)}
        ipucu="Veliye iletilir; boş bırakılırsa kaldırılır. Yeni şifre kaydedince etkinleşir."
      />
      <div>
        <Buton
          type="button"
          disabled={kilitli}
          onClick={() => {
            try {
              degistir(veliParolasiUret());
              setHata(null);
            } catch {
              setHata("Güvenli şifre üretilemedi. Güncel bir tarayıcıyla tekrar deneyin.");
            }
          }}
        >
          Şifre üret
        </Buton>
      </div>
      <p className="m-0 text-xs text-murekkep-3">
        Meyve, sebze, gezegen, ay ve diğer kategorilerden iki rastgele kelime ve iki rakam.
      </p>
      {hata && <p role="alert" className="m-0 text-xs text-hata">{hata}</p>}
    </div>
  );
}

export function VeliParolasi({
  kisiId,
  mevcutParola,
  kimlikNo,
  kaydedildi,
}: {
  kisiId: string;
  mevcutParola: string | null;
  kimlikNo: string | null;
  kaydedildi: () => void;
}) {
  const [taslak, setTaslak] = useState(mevcutParola ?? "");
  const kaydet = useMutation({
    mutationFn: () => apiYaz("PATCH", `/kisi/${kisiId}`, { parola: taslak.trim() || null }),
    onSuccess: kaydedildi,
  });
  const degisti = taslak.trim() !== (mevcutParola ?? "");

  return (
    <section aria-label="Veli giriş şifresi" className="flex min-w-0 flex-col gap-3">
      <h4 className="m-0 text-sm font-semibold text-murekkep-3">Veli giriş şifresi</h4>
      {mevcutParola && (
        <div>
          <p className="m-0 mb-1 text-xs text-murekkep-3">Kayıtlı şifre</p>
          <SirKopyala deger={mevcutParola} etiket="Parolayı" />
        </div>
      )}
      {!kimlikNo && (
        <p className="m-0 text-xs text-murekkep-3">
          Velinin giriş yapabilmesi için öğrenciye kimlik numarası da ekleyin.
        </p>
      )}
      <ParolaAlani deger={taslak} degistir={setTaslak} kilitli={kaydet.isPending} />
      {degisti && (
        <>
          <p role="status" className="m-0 text-xs text-murekkep-2">
            Şifre henüz kaydedilmedi. Kaydedince eski şifre ve açık veli oturumları geçersiz olur.
          </p>
          <div className="flex flex-wrap gap-2">
            <Buton tur="birincil" yukleniyor={kaydet.isPending} onClick={() => kaydet.mutate()}>
              Şifreyi kaydet
            </Buton>
            <Buton tur="sessiz" disabled={kaydet.isPending} onClick={() => {
              setTaslak(mevcutParola ?? "");
              kaydet.reset();
            }}>
              Vazgeç
            </Buton>
          </div>
        </>
      )}
      <IslemDurumu hata={kaydet.error} />
    </section>
  );
}
